<template>
    <h2 style="text-transform: none !important;">{{ subStepTitlePartOne}} <span style="white-space:nowrap;">{{ subStepTitlePartTwo }} <span id="tooltip-id" ref="tooltip-id" @mouseover="showTooltip" @mouseleave="hideTooltip" v-show="hasTooltip" class="label-tooltip rounded-circle">?<span v-show="activeTooltip" class="calc-tooltip">
                    Depreciation is a tax deduction available to property investors.
                    It allows you to claim a tax deduction for the wear and tear over time on
                    any old or new investment property. This estimator is only a guide based on
                    a few simple parameters. It is calculated using the ‘Diminishing Value’ rather than
                    ‘Prime Cost’ method. Please refer to your tax specialist for the method best suited
                    to your situation.
                    NOTE: If <span class="text-danger">NO RESULTS</span> appears the user will need to adjust some of the parameters to get a result.
                    Usually start by adjusting the ‘Standard of Finish’. For further help please refer to
        <a class="text-danger" href="https://www.washingtonbrown.com.au/depreciation/calculator/" target="_blank">Washington Brown’s website</a><div class="arrow-down"></div></span></span></span></h2>
</template>

<script>
    export default {
        name: "sub-step-title",
        data () {
            return {
                activeTooltip: false
            }
        },
        props: {
            subStepTitle: String,
            hasTooltip: Boolean
        },
        methods: {
            showTooltip: function () {
                this.activeTooltip = true;
            },
            hideTooltip: function () {
                this.activeTooltip = false;
            }
        },
        computed: {
            subStepTitlePartOne: function () {
                return this.subStepTitle.substring(0, this.subStepTitle.lastIndexOf(" ") + 1);
            },
            subStepTitlePartTwo: function () {
                return this.subStepTitle.substring(this.subStepTitle.lastIndexOf(" ") + 1);
            },
            tooltipText: function () {
                return "Depreciation is a tax deduction available to property investors. " +
                    "It allows you to claim a tax deduction for the wear and tear over time on " +
                    "any old or new investment property. This estimator is only a guide based on " +
                    "a few simple parameters. It is calculated using the ‘Diminishing Value’ rather than " +
                    "‘Prime Cost’ method. Please refer to your tax specialist for the method best suited " +
                    "to your situation.\n" +
                    "NOTE: If NO RESULTS appears the user will need to adjust some of the parameters to get a result. " +
                    "Usually start by adjusting the ‘Standard of Finish’. For further help please refer to " +
                    "Washington Brown’s website";
            }
        },
        mounted() {

            let $vm = this;
            var tooltip = this.$refs['tooltip-id'];
            tooltip.addEventListener('touchstart', function () {
                $vm.activeTooltip = !$vm.activeTooltip;
            })
        }
    }
</script>

<style scoped>

    h2 {
        background: rgb(237, 239, 241);
        font-family: 'Roboto', Arial, serif;
        color: #465978;
        padding-top: 10px;
        padding-bottom: 10px;
        font-weight: bold;
        text-align: center;
    }

    .label-tooltip {
        background-color: #ee3124;
        width: 20px;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        display: inline-block;
        font-size: 16px;
        vertical-align: top;
        margin-top: 10px;
        font-family: 'Roboto', Arial, serif;
        position: relative;
        cursor: pointer;
        height: 0;
        padding: 10px 0%;
        line-height: 0;
        text-align: center;
    }

    .calc-tooltip {
        position: absolute;
        z-index: 99;
        top: -60px;
        left: 0px;
        background-color: #465978;
        height: 58px;
        width: 250px;
        color: #fff;
        line-height: 16px;
        padding: 8px;
        opacity: 0.9;
        margin-left: -475%;
        overflow: hidden;
        text-transform: none !important;
        letter-spacing: normal !important;
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid black;
        margin-left: 88px;
        margin-bottom: 0;
        margin-top: 5px;
    }

    a {
        letter-spacing: normal !important;
        text-transform: none !important;
        font-size: 16px !important;
    }

    .estimated-first-year-depreciation-header .calc-tooltip {
        width: 460px;
        height: 186px;
        top: -187px;
        margin-left: -475%;
        font-size: 14px;
    }

    .estimated-first-year-depreciation-header .arrow-down {
        margin-left: 417px;
    }

    @media (min-width: 563px) {
        .calc-tooltip {
            margin-left: 0;
            margin-right: -75%;
            right: 0;
            left: initial;
        }

        .arrow-down {
            margin-left: 208px;
        }
    }

    @media (max-width: 546px) {
        .estimated-first-year-depreciation-header .calc-tooltip {
            height: 208px;
            width: 364px;
            top: -209px;
            margin-left: 0;
            margin-right: -358%;
            right: 0;
            left: initial;
            padding: 0;
        }

        .estimated-first-year-depreciation-header .arrow-down {
            margin-left: 273px;
        }
    }

    @media (min-width: 547px) and (max-width: 586px) {
        .estimated-first-year-depreciation-header .calc-tooltip {
            margin-left: 0;
            margin-right: 0;
            right: 0;
            left: initial;
        }

        .estimated-first-year-depreciation-header .arrow-down {
            margin-left: 431px;
        }
    }

    @media (max-width: 506px) {
        .calc-tooltip {
            margin-left: 0;
            margin-right: -75%;
            right: 0;
            left: initial;
        }

        .arrow-down {
            margin-left: 208px;
        }
    }

    @media (max-width: 392px) {
        .estimated-first-year-depreciation-header .calc-tooltip {
            height: 225px;
            width: 334px;
            top: -226px;
            margin-left: 0;
            margin-right: -258%;
            right: 0;
            left: initial;
            padding: 0;
        }

        .estimated-first-year-depreciation-header .arrow-down {
            margin-left: 263px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/SubStepTitle.vue